import { Observable } from 'rxjs';
import {
  HttpWalletAccountBindingCallbackCollectionResponse,
  HttpWalletAccountBindingCollectionResponse,
  HttpWalletAccountPinCallbackCollectionResponse,
  HttpWalletAccountRequestOtpCollectionResponse,
  HttpWalletAccountValidateOtpCollectionResponse,
} from '../../data/repository/fs-wallet-account/http-fs-wallet-account.collection';
import { OtpRequestDTO } from '../usecase/fs-wallet-account/interface/otp-request.dto';
import { OtpValidateDTO } from '../usecase/fs-wallet-account/interface/otp-validate.dto';
import { BindingCallbackDTO } from '../usecase/fs-wallet-account/interface/binding-callback.dto';
import { PinCallbackDTO } from '../usecase/fs-wallet-account/interface/pin-callback.dto';

export abstract class FSWalletAccountRepository {
  abstract RequestWalletOtp(
    data: OtpRequestDTO
  ): Observable<HttpWalletAccountRequestOtpCollectionResponse>;
  abstract ValidateWalletOtp(
    data: OtpValidateDTO
  ): Observable<HttpWalletAccountValidateOtpCollectionResponse>;
  abstract WalletBinding(
    wallet_id: string
  ): Observable<HttpWalletAccountBindingCollectionResponse>;
  abstract WalletBindingCallback(
    data: BindingCallbackDTO
  ): Observable<HttpWalletAccountBindingCallbackCollectionResponse>;
  abstract WalletPinCallback(
    data: PinCallbackDTO
  ): Observable<HttpWalletAccountPinCallbackCollectionResponse>;
}
